import * as types from './types';

export const setSiteId = (siteId: string | null) => ({
  type: types.SITE_PICKER_SET_SITE,
  payload: siteId,
});
